import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-satisfaction',
  templateUrl: './customer-satisfaction.component.html',
  styleUrl: './customer-satisfaction.component.scss'
})

export class CustomerSatisfactionComponent implements OnInit {

  customerSatisfactionList = [
    {
      id: 1,
      title: 'PARTH INTERNATIONAL',
      pdf: 'assets/pdf/customer-satisfaction/parth-international.pdf'
    },
    {
      id: 2,
      title: 'VINOD DENIM - (1)',
      pdf: 'assets/pdf/customer-satisfaction/vinod-denim-1.pdf'
    },
    {
      id: 3,
      title: 'BHASKAR INDUSTRIES - (1)',
      pdf: 'assets/pdf/customer-satisfaction/bhaskar-industries-1.pdf'
    },
    {
      id: 4,
      title: 'STALLION DENIM',
      pdf: 'assets/pdf/customer-satisfaction/stallion-denim.pdf'
    },
    {
      id: 5,
      title: 'RK DYEING',
      pdf: 'assets/pdf/customer-satisfaction/rk-dyeing.pdf'
    },
    {
      id: 6,
      title: 'DI SHIMLA SIZERS PVT LTD',
      pdf: 'assets/pdf/customer-satisfaction/di-shimla-sizers.pdf'
    },
    {
      id: 7,
      title: 'GREENPRO VENTURES PVT LTD',
      pdf: 'assets/pdf/customer-satisfaction/greenpro.pdf'
    },
    {
      id: 8,
      title: 'GARWARE TECHNICAL FIBERS LTD',
      pdf: 'assets/pdf/customer-satisfaction/garware.pdf'
    },
    {
      id: 9,
      title: 'DONG BANG TEXTILES LIMITED',
      pdf: 'assets/pdf/customer-satisfaction/dong-bang.pdf'
    },
    {
      id: 10,
      title: 'LEAD TEX CONSULTANT LTD',
      pdf: 'assets/pdf/customer-satisfaction/lead-tex-consultant.pdf'
    },
    {
      id: 11,
      title: 'ULTRA DENIM PVT LTD',
      pdf: 'assets/pdf/customer-satisfaction/ultra-denim.pdf'
    },
    {
      id: 12,
      title: 'VINOD-DENIM - (2)',
      pdf: 'assets/pdf/customer-satisfaction/vinod-denim-2.pdf'
    },
    {
      id: 13,
      title: 'BHASKAR INDUSTRIES - (2)',
      pdf: 'assets/pdf/customer-satisfaction/bhaskar-industries-2.pdf'
    }
  ];
  constructor() { }

  ngOnInit(): void {}

}
